module.exports = __webpack_public_path__ + "media/images/social/logo-facebook-d8d03e542e484a55802b97935e662b78.svg";